import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-EDM-quit",
  "use": "icon-EDM-quit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-EDM-quit\"><defs><style type=\"text/css\"></style></defs><path d=\"M385.92 0v85.312H85.76v853.376h300.16V1024H0V0h385.92z m307.008 183.168L1023.424 512l-330.496 328.832-60.608-60.352 226.88-225.792H214.4V469.312h644.928L632.32 243.52l60.608-60.352z\" p-id=\"13229\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol